import { BaixaCobranca } from './../../../model/baixa-cobranca.model';
import { TarefasLeilaoService } from './tarefas-leilao.service';
import { Component, OnInit } from "@angular/core";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from '@bndes/bndes-ux4/bn-alerts';
import moment from 'moment';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';
import {Estado} from '../../../model/estado.model';
import {ActivatedRoute} from '@angular/router';


@Component({
  selector: 'app-tarefas-leilao',
  templateUrl: './tarefas-leilao.component.html',
  styleUrls: ['./tarefas-leilao.component.scss'],
  standalone: false,
})
export class TarefasLeilaoComponent implements OnInit {

  public baixaCobranca: BaixaCobranca;
  public ideLeilao: number;
  estados: Estado[] = [];
  estado: Estado = new Estado();


  constructor(
    private leilaoService: TarefasLeilaoService,
    private messageService: MessageChannelService,
    private alertService: BnAlertsService,
    private loadingService: BnLoadingService,
    private fileUtils: FileUtilsService,
    private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.estados = this.activatedRoute.snapshot.data["dominios"].estadosLeilao;
    console.log(this.estados);
  }



  public simularBaixaLeilao() {
    this.loadingService.bloqueiaTela();
      this.leilaoService.simularBaixaLeilao(this.ideLeilao).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Simulação de baixa do Leilão realizada com sucesso.'
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }


  public simularAuditoriaBaixaLeilao() {
    this.loadingService.bloqueiaTela();
      this.leilaoService.simularAuditoriaBaixaLeilao().subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Simulação de Auditoria de baixa do Leilão realizada com sucesso.'
        })
        this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public alteracaoEstadoLeilao() {
    this.loadingService.bloqueiaTela();
    this.leilaoService.alteracaoEstadoLeilao(this.ideLeilao, this.estado).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Alteração de estado do Leilão realizada com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }


}
